@if (timeOut()) {
  <app-timeout></app-timeout>
} @else if (loading()) {
  <div class="flex justify-content-center align-items-center h-full">
    <p-progressSpinner class="customProgressSpinner" />
  </div>
}
<div class="customerMap" [ngClass]="{ hide: loading() || timeOut() }">
  <div (click)="goBack()" class="mapBar">
    @if (selectedAsset() && selectedAsset()!.assetType !== "CUSTOMER") {
      <app-svg-icon iconName="arrow_up" iconColor="primary" class="backButton"></app-svg-icon>
    }
  </div>
  @if (floorMapUrl()) {
    <div class="floorMapContainer">
      <div class="floorMap">
        <img [src]="floorMapUrl()" id="mapPageFloorMap" alt="Floor Map" />

        @for (point of floorMapPoints; track point) {
          <div
            class="floorMapPointContainer pointer markerContainer"
            [ngStyle]="getCoordinates(point)"
            (click)="goToNextLevel(point)"
          >
            <img class="floorMapPoint" [src]="getPointImage(point)" alt="Location marker on floor map" />
            <span class="markerLabel">{{ point.label }}</span>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="container" id="map"></div>
  }
</div>
